import { Box, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import DataNitivSyncIcon from "../DataNitivSyncIcon/DataNitivSyncIcon";

export default function TextLabel({
  text,
  header,
  description,
  subHeading,
  fontSize,
  required = false,
  fontColor = null,
  dnSync = false,
}) {
  return (
    <Typography
      sx={{
        fontFamily: "Urbanist, Verdana, Arial, sans-serif",
        fontSize: fontSize,
        ...(!description && {
          fontWeight: "bold",
          letterSpacing: subHeading ? "0" : "0.10em",
        }),
        color: header ? "#3299ff" : fontColor ? fontColor : "#3F5765",
        ...(dnSync && { mb: 0.5 }),
      }}
    >
      {dnSync && <DataNitivSyncIcon />}
      {text}
      {required && <Box sx={{ color: "red", display: "inline" }}> *</Box>}
    </Typography>
  );
}

TextLabel.propTypes = {
  text: PropTypes.string,
  description: PropTypes.any,
  fontSize: PropTypes.number,
  header: PropTypes.any,
  subHeading: PropTypes.any,
  required: PropTypes.bool,
  dnSync: PropTypes.bool,
};
